module.exports = __webpack_public_path__ + "static/media/wheel-not-active.fa1d90fc.png";